import type { LucideIcon } from "lucide-react";
import { BookingContactModal } from "./BookingContactModal";

export type HeroValueItem = {
  icon: LucideIcon;
  label: string;
};

interface HeroValueBarProps {
  items: HeroValueItem[];
}

const HeroValueBar = ({ items }: HeroValueBarProps) => {
  return (
    <section
      aria-label="Key highlights"
      className="bg-[hsl(0,0%,5%)] border-y border-[hsl(38,20%,22%)]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-3.5">
        <ul className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-0 sm:divide-x sm:divide-[hsl(38,20%,22%)]">
          {items.map((item) => {
            const content = (
              <>
                <item.icon
                  size={16}
                  strokeWidth={1.75}
                  className="text-gold shrink-0"
                  aria-hidden="true"
                />
                <span className="text-[11px] sm:text-xs tracking-[0.15em] uppercase font-medium">
                  {item.label}
                </span>
              </>
            );

            if (item.label === "BOOK DIRECT") {
              return (
                <li key={item.label} className="flex justify-center sm:px-6">
                  <BookingContactModal>
                    <button className="flex items-center justify-center gap-2.5 text-[hsl(40,30%,90%)] hover:text-gold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-[hsl(0,0%,5%)] rounded-sm">
                      {content}
                    </button>
                  </BookingContactModal>
                </li>
              );
            }

            return (
              <li
                key={item.label}
                className="flex items-center justify-center gap-2.5 sm:px-6 text-[hsl(40,30%,90%)]"
              >
                {content}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default HeroValueBar;
